import * as v from 'valibot';

import {
  type Entities,
  type Filters,
  type FiltersUpdateApi,
  type Option,
  optionSchema,
  paginatedSchema,
} from './_core.model';

export const transportationModeApiSchema = v.object({
  codeDesc: v.string(),
  codeId: v.optional(v.string()),
  id: v.number(),
  lookupCodeType: v.string(),
});

export const transportationModeSchema = v.object({
  ...transportationModeApiSchema.entries,
  ...optionSchema.entries,
});

export const transportationModesApiSchema = paginatedSchema(transportationModeApiSchema);

export type TransportationModeApi = v.InferOutput<typeof transportationModeApiSchema>;
export type TransportationModesApi = v.InferOutput<typeof transportationModesApiSchema>;

export type TransportationModeFilters = Filters<TransportationModeApi>;

export type TransportationModeFiltersUpdateApi = FiltersUpdateApi<TransportationModeApi>;

export type TransportationMode = Prettify<Option<v.InferOutput<typeof transportationModeSchema>>>;

export type TransportationModes = Entities<TransportationMode>;
